import {createUseQuery} from "@irati/utils/services/apollo"
import GroupCelebrationQuery from "@irati/recognition/apollo/query/GroupCelebration"
import {GroupCelebration, QueryGroupCelebrationArgs} from "@irati/types"

export const useScheduledGroupCelebrationQuery = createUseQuery<GroupCelebration, QueryGroupCelebrationArgs>(GroupCelebrationQuery, {
  key: "groupCelebration"
})
